import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import Icon from "../../Icon";
import Button from "../../Button";
import style from "../../Form/Select/SelectPill/style.module.scss";
import styleURLPill from "./style.module.scss";
export default function SelectURLPill(props) {
    const { option, removable = false, onEdit, onRemove } = props;
    const removeOption = (event) => {
        if (onRemove) {
            onRemove();
        }
        event.stopPropagation();
    };
    function editOption(event) {
        if (onEdit) {
            onEdit();
        }
        event.stopPropagation();
    }
    let urlToShow = "";
    if (option.url) {
        urlToShow = option.url;
    }
    const urlLabel = [];
    if (option.label) {
        urlLabel.push(_jsx("div", { className: styleURLPill["select-url-pill__page-label"], children: option.label }));
    }
    return (_jsxs("div", { className: style["select-pill"], children: [_jsxs(Button, { variation: "none", className: classNames(style["select-pill__main"], styleURLPill["select-pill-url__main"], {
                    [style["select-pill__main--delete"]]: removable,
                }), onClick: editOption, children: [urlLabel, _jsx("span", { className: styleURLPill["select-url-pill__url"], children: urlToShow }), removable ? null : (_jsx("span", { className: style["select-pill__main__edit"], children: _jsx(Icon, { name: "caret--thin--down" }) }))] }), removable ? (_jsxs(Button, { variation: "none", className: style["select-pill__delete"], onClick: removeOption, children: [_jsx(Icon, { name: "xmark--thin" }), _jsx("span", { className: "visually-hidden", children: "Remove option" })] })) : null] }));
}
